import Cookies from 'js-cookie'

const TokenKey = "User-Pc-Token"
const UserInfoKey = "User-Pc-Info"

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}

export function getUserInfo() {
    let str = Cookies.get(UserInfoKey)
    if (str) {
        return JSON.parse(str)
    }
    return null
}

export function setUserInfo(userInfo) {
    if (userInfo){
        let str = JSON.stringify(userInfo)
        return Cookies.set(UserInfoKey, str)
    }
}

export function removeUserInfo() {
    return Cookies.remove(UserInfoKey)
}